import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef } from 'react';
import useTextStyles from '../../hooks/use-text-styles.esm.js';
import Slot from '../layout/slot/slot.esm.js';

var _excluded = ["children", "className", "color", "ellipsis", "leading", "moreTrigger", "size", "tracking", "variant", "weight"];
var TextContainer = /*#__PURE__*/forwardRef(function TextContainer(props, ref) {
  var children = props.children,
    className = props.className,
    color = props.color,
    ellipsis = props.ellipsis,
    leading = props.leading,
    moreTrigger = props.moreTrigger,
    size = props.size,
    tracking = props.tracking,
    variant = props.variant,
    weight = props.weight,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = useTextStyles({
    variant: variant,
    className: className,
    color: color,
    ellipsis: ellipsis,
    leading: leading,
    size: size,
    tracking: tracking,
    weight: weight
  });
  return /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("section", _extends({
    ref: ref,
    className: classes
  }, rest), children), moreTrigger);
});
TextContainer.displayName = 'TextContainer';

export { TextContainer as default };
//# sourceMappingURL=text-container.esm.js.map
